import { useTab, useWalletAddressProviderApi } from 'BreetHooks';
import { type ReactNode } from 'react';

import { type TABTYPE } from '../DialogWithdrawUsdRequest.helpers';
import { WithdrawUsdRequestContext } from './FormContext';

export const WithdrawUsdRequestProvider = ({ children }: { children?: ReactNode }) => {
	const tabProps = useTab<TABTYPE>('Send Crypto');

	const providerValue = useWalletAddressProviderApi<TABTYPE>({ tabProps });

	return <WithdrawUsdRequestContext.Provider value={providerValue}>{children}</WithdrawUsdRequestContext.Provider>;
};
